(() => {
  const root = window.Shopify?.routes?.root || '/';
  const stringsNode = document.getElementById('ps-strings');
  const strings = stringsNode ? JSON.parse(stringsNode.textContent) : {};
  let previousFocus;
  let cartBusy = false;
  let toastTimer;
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];
  const showToast = text => {
    const el = $('.ps-toast');
    if (!el) return;
    clearTimeout(toastTimer);
    el.textContent = text;
    el.hidden = false;
    toastTimer = setTimeout(() => { el.hidden = true; }, 3500);
  };
  const openDialog = id => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('dialog[open]').forEach(el => el.close());
    previousFocus = document.activeElement;
    dialog.showModal();
    $$('[data-ps-open]').forEach(el => el.setAttribute('aria-expanded', String(el.dataset.psOpen === id)));
    return true;
  };
  const syncCount = count => $$('[data-ps-cart-count]').forEach(el => { el.textContent = count; });
  const updateCartSection = (html, shouldOpen = false) => {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const replacement = doc.getElementById('shopify-section-ps-cart-drawer');
    const current = document.getElementById('shopify-section-ps-cart-drawer');
    if (!replacement || !current) return false;
    const wasOpen = Boolean($('#ps-cart')?.open);
    current.replaceWith(replacement);
    if (wasOpen || shouldOpen) openDialog('ps-cart');
    return true;
  };
  const refreshCart = async (shouldOpen = false) => {
    const response = await fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(strings.error);
    const cart = await response.json();
    syncCount(cart.item_count);
    const sectionResponse = await fetch(`${root}?sections=ps-cart-drawer`, {headers: {Accept: 'application/json'}});
    if (!sectionResponse.ok) throw new Error(strings.error);
    const sections = await sectionResponse.json();
    return updateCartSection(sections['ps-cart-drawer'], shouldOpen);
  };
  const setCartBusy = busy => {
    cartBusy = busy;
    const dialog = $('#ps-cart');
    if (!dialog) return;
    dialog.setAttribute('aria-busy', String(busy));
    $$('input, button[name="checkout"], [data-ps-quantity]', dialog).forEach(el => { el.disabled = busy; });
  };
  const changeLine = async (id, quantity) => {
    if (cartBusy || !Number.isSafeInteger(quantity) || quantity < 0) return;
    setCartBusy(true);
    const errorEl = $('.ps-cart-error');
    if (errorEl) errorEl.hidden = true;
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id, quantity, sections: ['ps-cart-drawer'], sections_url: root})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.error);
      syncCount(data.item_count);
      if (!updateCartSection(data.sections?.['ps-cart-drawer'], true)) await refreshCart(true);
    } catch (error) {
      const el = $('.ps-cart-error');
      if (el) { el.textContent = error.message || strings.error; el.hidden = false; }
      try { await refreshCart(true); } catch (_) {}
      showToast(error.message || strings.error);
    } finally { setCartBusy(false); }
  };
  const syncProduct = section => {
    const choice = $('input[data-ps-tier]:checked', section);
    if (!choice) return;
    $$('[data-ps-price]', section).forEach(el => { el.textContent = choice.dataset.price; });
    const includes = $('[data-ps-includes]', section);
    if (includes) includes.textContent = choice.dataset.includes;
    const label = $('[data-ps-sticky-tier]', section);
    if (label) label.textContent = choice.dataset.name;
    $$('[data-ps-perk-panel]', section).forEach(panel => { panel.hidden = panel.dataset.psPerkPanel !== choice.dataset.psTier; });
    const perks = $('[data-ps-sticky-perks]', section);
    if (perks) perks.textContent = ({1: strings.stickySolo, 2: strings.stickyBuddy, 3: strings.stickyCrew})[choice.dataset.psTier] || '';
    $$('[data-ps-atc], [data-ps-sticky-add]', section).forEach(button => { button.disabled = choice.disabled; });
    const atcLabel = $('[data-ps-atc-label]', section);
    if (atcLabel && !choice.disabled) atcLabel.textContent = strings.add;
    if (section.dataset.psReady) {
      const url = new URL(location.href);
      url.searchParams.set('variant', choice.value);
      history.replaceState({}, '', url);
    }
    section.dataset.psReady = 'true';
  };
  const initProducts = () => {
    $$('[data-ps-product]').forEach(section => {
      syncProduct(section);
      if (section.dataset.psObserved) return;
      section.dataset.psObserved = 'true';
      const form = $('.ps-product-form', section);
      const sticky = $('.ps-sticky-buy', section);
      if (!form || !sticky || !window.IntersectionObserver) return;
      new IntersectionObserver(entries => {
        const e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }, {threshold: 0, rootMargin: '-100px 0px 0px 0px'}).observe($('[data-ps-atc]', form) || form);
    });
    updateDispatchDates();
  };
  const showGallerySlide = (gallery, index) => {
    const slides = $$('[data-ps-slide]', gallery);
    if (!slides.length || !Number.isFinite(index)) return;
    index = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.hidden = i !== index;
      if (slide.hidden) $$('video', slide).forEach(video => video.pause());
    });
    $$('[data-ps-thumb]', gallery).forEach(thumb => thumb.setAttribute('aria-pressed', String(Number(thumb.dataset.psThumb) === index)));
    const counter = $('[data-ps-gallery-current]', gallery);
    if (counter) counter.textContent = String(index + 1);
    const thumb = $(`[data-ps-thumb="${index}"]`, gallery);
    if (thumb) {
      const strip = thumb.parentElement;
      if (thumb.offsetLeft < strip.scrollLeft) strip.scrollLeft = thumb.offsetLeft;
      else if (thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = thumb.offsetLeft + thumb.offsetWidth - strip.clientWidth;
    }
  };
  const stepGallery = (gallery, step) => {
    const selected = $('[data-ps-thumb][aria-pressed="true"]', gallery);
    showGallerySlide(gallery, Number(selected?.dataset.psThumb || 0) + step);
  };
  const updateDispatchDates = () => {
    const nodes = $$('[data-ps-dispatch-date]');
    if (!nodes.length) return;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York', year:'numeric', month:'numeric', day:'numeric'}).formatToParts(new Date()).map(x => [x.type, x.value]));
    const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const holidayKeys = new Set();
    const key = value => value.toISOString().slice(0,10);
    for (const year of [date.getUTCFullYear(), date.getUTCFullYear() + 1]) {
      for (const [month, day] of [[0,1],[5,19],[6,4],[10,11],[11,25]]) {
        const holiday = new Date(Date.UTC(year,month,day));
        if (holiday.getUTCDay() === 0) holiday.setUTCDate(day + 1);
        if (holiday.getUTCDay() === 6) holiday.setUTCDate(day - 1);
        holidayKeys.add(key(holiday));
      }
      for (const [month, weekday, occurrence] of [[0,1,3],[1,1,3],[8,1,1],[9,1,2],[10,4,4]]) {
        const first = new Date(Date.UTC(year,month,1));
        holidayKeys.add(key(new Date(Date.UTC(year,month,1 + (weekday - first.getUTCDay() + 7) % 7 + (occurrence - 1) * 7))));
      }
      const memorial = new Date(Date.UTC(year,5,0));
      memorial.setUTCDate(memorial.getUTCDate() - (memorial.getUTCDay() + 6) % 7);
      holidayKeys.add(key(memorial));
    }
    let businessDays = 0;
    while (businessDays < 3) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !holidayKeys.has(key(date))) businessDays++;
    }
    const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {timeZone:'UTC', weekday:'short', month:'short', day:'numeric'}).format(date);
    nodes.forEach(node => { node.textContent = formatted; });
  };
  let galleryTouch;
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' || !(event.target instanceof Element)) return;
    const stage = event.target.closest('.ps-gallery-stage');
    if (stage) galleryTouch = {id:event.pointerId, x:event.clientX, y:event.clientY, gallery:stage.closest('[data-ps-gallery]')};
  }, {passive:true});
  document.addEventListener('pointerup', event => {
    if (!galleryTouch || galleryTouch.id !== event.pointerId) return;
    const dx = event.clientX - galleryTouch.x;
    const dy = event.clientY - galleryTouch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) stepGallery(galleryTouch.gallery, dx < 0 ? 1 : -1);
    galleryTouch = null;
  }, {passive:true});
  document.addEventListener('pointercancel', () => { galleryTouch = null; }, {passive:true});
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element) || !event.target.matches('.ps-gallery-stage, [data-ps-thumb]')) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const gallery = event.target.closest('[data-ps-gallery]');
    stepGallery(gallery, event.key === 'ArrowRight' ? 1 : -1);
    if (event.target.matches('[data-ps-thumb]')) $('[data-ps-thumb][aria-pressed="true"]', gallery)?.focus({preventScroll:true});
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-ps-open]');
    if (opener) {
      if (openDialog(opener.dataset.psOpen)) {
        event.preventDefault();
        if (opener.dataset.psOpen === 'ps-cart') refreshCart().catch(() => {});
      }
      return;
    }
    const closer = target.closest('[data-ps-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (target.matches('dialog')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
    }
    const thumb = target.closest('[data-ps-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-ps-gallery]');
      showGallerySlide(gallery, Number(thumb.dataset.psThumb));
    }
    const galleryArrow = target.closest('[data-ps-gallery-step]');
    if (galleryArrow) stepGallery(galleryArrow.closest('[data-ps-gallery]'), Number(galleryArrow.dataset.psGalleryStep));
    const upgrade = target.closest('[data-ps-select-tier]');
    if (upgrade) {
      const section = upgrade.closest('[data-ps-product]');
      const choice = $(`input[data-ps-tier="${upgrade.dataset.psSelectTier}"]`, section);
      if (choice && !choice.disabled) { choice.checked = true; syncProduct(section); choice.focus({preventScroll:true}); }
    }
    const motion = target.closest('[data-ps-motion-toggle]');
    if (motion) {
      const paused = motion.closest('[data-ps-mountain-section]').classList.toggle('ps-motion-paused');
      motion.setAttribute('aria-pressed', String(paused));
      motion.setAttribute('aria-label', paused ? strings.playMountains : strings.pauseMountains);
      const label = $('[data-ps-motion-label]', motion);
      if (label) label.textContent = paused ? strings.playMountains : strings.pauseMountains;
      const icon = $('[aria-hidden]', motion);
      if (icon) icon.textContent = paused ? '▷' : 'Ⅱ';
    }
    const quantityButton = target.closest('[data-ps-quantity]');
    if (quantityButton) {
      const input = $('input', quantityButton.closest('.ps-quantity'));
      const next = Math.max(0, Number(input.value) + Number(quantityButton.dataset.psQuantity));
      input.value = next;
      if (input.hasAttribute('data-ps-line-quantity')) changeLine(input.dataset.lineKey, next);
    }
    const remove = target.closest('[data-ps-remove]');
    if (remove && remove.closest('#ps-cart')) {
      event.preventDefault();
      changeLine(remove.dataset.psRemove, 0);
    }
    const sticky = target.closest('[data-ps-sticky-add]');
    if (sticky) $('.ps-product-form', sticky.closest('[data-ps-product]'))?.requestSubmit();
    const menuLink = target.closest('#ps-menu a');
    if (menuLink) $('#ps-menu')?.close();
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    $$(`[data-ps-open="${event.target.id}"]`).forEach(el => el.setAttribute('aria-expanded', 'false'));
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
  }, true);
  document.addEventListener('change', event => {
    const el = event.target;
    if (!(el instanceof HTMLInputElement)) return;
    if (el.matches('[data-ps-tier]')) syncProduct(el.closest('[data-ps-product]'));
    if (el.matches('[data-ps-line-quantity]')) changeLine(el.dataset.lineKey, Number(el.value));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.ps-product-form')) return;
    event.preventDefault();
    if (form.dataset.psSubmitting === 'true') return;
    const selected = $('input[name="id"]:checked', form);
    if (!selected || selected.disabled) return;
    const section = form.closest('[data-ps-product]');
    const buttons = $$('[data-ps-atc], [data-ps-sticky-add]', section);
    const label = $('[data-ps-atc-label]', form);
    const errorEl = $('.ps-form-error', form);
    form.dataset.psSubmitting = 'true';
    buttons.forEach(button => { button.disabled = true; });
    if (label) label.textContent = strings.adding;
    if (errorEl) errorEl.hidden = true;
    let added = false;
    try {
      const body = new FormData(form);
      body.append('sections', 'ps-cart-drawer');
      body.append('sections_url', root);
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', body, headers: {Accept: 'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.error);
      added = true;
      updateCartSection(data.sections?.['ps-cart-drawer'], true);
      await refreshCart(true);
      document.dispatchEvent(new CustomEvent('ps:cart-updated', {detail: {source: 'product'}}));
    } catch (error) {
      if (added) { location.assign(`${root}cart`); return; }
      if (errorEl) { errorEl.textContent = error.message || strings.error; errorEl.hidden = false; }
    } finally {
      form.dataset.psSubmitting = 'false';
      buttons.forEach(button => { button.disabled = false; });
      if (label) label.textContent = strings.add;
    }
  });
  document.addEventListener('shopify:section:load', initProducts);
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  initProducts();
})();
